import { connect } from "react-redux";
import AuthGuard from "../components/Auth/AuthGuard"

const mapStatetoProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  otpFlag: state.auth.otpFlag,
  email: state.auth.email,
})

const AuthGuardContainer = connect(
    mapStatetoProps
)(AuthGuard);

export default AuthGuardContainer
